import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import CheckboxGroup from "../../../../ui/molecules/CheckBoxGroup"
import { CoCTabPartialTransformationEnum, CoCTypeEnum } from "./dataservice/dto"
import { GetAllGGNotificationTab, GGNotificationTabUpdate, resetGetAllTabStatus, setTabIdToUpdate, setTabUpdateCocPartialTransformations, setTabUpdateCocTypes, setTabUpdateGGNLabelLogoLicense, setTabUpdatePartialTransformation, setTabUpdateRequest, setTabUpdateSubcontractedActivity } from "./slice"
import { SingleCheckbox } from "../../../../ui/molecules/SingleCheckbox"
import TextArea from "../../../../ui/molecules/textArea"
import Button from "../../../../ui/molecules/button"

export function GlobalGapCoCRight() {
    const dispatch = useAppDispatch()
    const ggNotificationState = useAppSelector(state => state.ggNotification)
    const ggNotificationCoCState = useAppSelector(state => state.ggNotificationCoC)
    const [selectedCoC, setSelectedCoC] = useState<CoCTypeEnum[]>([])
    const [selectedCoCPartial, setSelectedCoCPartial] = useState<CoCTabPartialTransformationEnum[]>([])
    const [partialTransformation, setPartialTransformation] = useState<boolean>(false)
    const [ggnLabelLogo, setGgnLabelLogo] = useState<boolean>(false)

    const handleCoCChange = (value: CoCTypeEnum) => {
        let currentCoC = [...selectedCoC]
        if (currentCoC.includes(value)) {
            currentCoC = currentCoC.filter(t => t !== value)
        }
        else {
            currentCoC.push(value)
        }
        setSelectedCoC(currentCoC)

        dispatch(setTabUpdateCocTypes(currentCoC))
    }

    const handleCoCPartialChange = (value: CoCTabPartialTransformationEnum) => {
        let currentCoC = [...selectedCoCPartial]
        if (currentCoC.includes(value)) {
            currentCoC = currentCoC.filter(t => t !== value)
        }
        else {
            currentCoC.push(value)
        }
        setSelectedCoCPartial(currentCoC)

        dispatch(setTabUpdateCocPartialTransformations(currentCoC))
    }

    useEffect(() => {
        dispatch(GetAllGGNotificationTab({
            itemsPerPage: 0,
            page: 0,
            ggNotificationId: ggNotificationState.ggNotificationIdToUpdate
        }))
    }, [])

    useEffect(() => {
        if (ggNotificationCoCState.getAllTabStatus === 'successfully' &&
            ggNotificationCoCState.getAllTabResponse !== undefined &&
            ggNotificationCoCState.getAllTabResponse.data.length > 0
        ) {
            dispatch(resetGetAllTabStatus())
            const req = ggNotificationCoCState.getAllTabResponse.data[0]
            dispatch(setTabIdToUpdate(req.id))
            dispatch(setTabUpdateRequest({
                cocTypes: req.cocTypes !== null ? req.cocTypes : [],
                partialTransformation: req.partialTransformation,
                cocPartialTransformations: req.cocPartialTransformations !== null ? req.cocPartialTransformations : [],
                ggnLabelLogoLicense: req.ggnLabelLogoLicense,
                subcontractedActivity: req.subcontractedActivity
            }))
        }
    }, [ggNotificationCoCState.getAllTabStatus])

    useEffect(() => {
        setSelectedCoC(ggNotificationCoCState.tabUpdateRequest.cocTypes)
        setSelectedCoCPartial(ggNotificationCoCState.tabUpdateRequest.cocPartialTransformations)
        setPartialTransformation(ggNotificationCoCState.tabUpdateRequest.partialTransformation)
        setGgnLabelLogo(ggNotificationCoCState.tabUpdateRequest.ggnLabelLogoLicense)
    }, [ggNotificationCoCState.tabUpdateRequest])

    return (
        <div>
            <div className="notify-container">
                <div className='notify-header'>
                    <div className='text-left'>
                        <span className='notify-title-bold' style={{ color: '#fff' }}>Domanda </span>
                        <span className='notify-title-bold' style={{ color: '#74A4A9' }}>/</span>
                        <span className='notify-title-bold' style={{ color: '#d9e6e8' }}> Scheda CoC</span>
                    </div>
                </div>

                <div style={{ padding: '24px' }}>

                    <div className="pb-3">
                        <div className="text-left notify-subtitle pb-2">
                            Tipologia CoC
                        </div>
                        <CheckboxGroup
                            name="coc_type"
                            options={Object.values(CoCTypeEnum)}
                            selectedValues={selectedCoC}
                            onChange={handleCoCChange}
                            optionLabels={{
                                [CoCTypeEnum.LAVORAZIONE]: "Lavorazione (Contatto fisico con il prodotto)",
                                [CoCTypeEnum.STOCCAGGIO]: "Stoccaggio (Contatto fisico con il prodotto)",
                                [CoCTypeEnum.BROKERAGGIO]: "Brokeraggio (Nessun contatto fisico con il prodotto)"
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <div className="text-left notify-text-content pb-3">
                            Trasformazione parziale
                        </div>
                        <div className="pb-[10px]">
                            <SingleCheckbox
                                label=''
                                checked={partialTransformation}
                                setChecked={(value) => {
                                    dispatch(setTabUpdatePartialTransformation(value))
                                    setPartialTransformation(value)
                                    if (!value) {
                                        setSelectedCoCPartial([])
                                        dispatch(setTabUpdateCocPartialTransformations([]))
                                    }
                                }}
                            />
                        </div>
                    </div>

                    {
                        ggNotificationCoCState.tabUpdateRequest.partialTransformation && (
                            <div>
                                <div className=" pl-3 pb-3">
                                    <div className="text-left notify-subtitle pb-2">
                                        Trasformazioni parziali CoC
                                    </div>
                                    <CheckboxGroup
                                        name="coc_partial_type"
                                        options={Object.values(CoCTabPartialTransformationEnum)}
                                        selectedValues={selectedCoCPartial}
                                        onChange={handleCoCPartialChange}
                                        optionLabels={{
                                            [CoCTabPartialTransformationEnum.TAGLIO]: "Taglio",
                                            [CoCTabPartialTransformationEnum.AFFETTATURA]: "Affettatura",
                                            [CoCTabPartialTransformationEnum.CUBETTATURA]: "Cubettatura",
                                            [CoCTabPartialTransformationEnum.CONGELAMENTO]: "Congelamento",
                                        }}
                                    />
                                </div>
                            </div>
                        )
                    }

                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center', borderBottom: '1px solid #d9e6e8' }}>
                        <div className="text-left notify-text-content pb-3">
                            Licenza per "GGN Label Logo"
                        </div>
                        <div className="pb-[10px]">
                            <SingleCheckbox
                                label=''
                                checked={ggnLabelLogo}
                                setChecked={(value) => {
                                    dispatch(setTabUpdateGGNLabelLogoLicense(value))
                                    setGgnLabelLogo(value)
                                }}
                            />
                        </div>
                    </div>

                    <div className="pb-3 pt-3">
                        <div className="text-left notify-subtitle">
                            Attività svolte in subappalto
                        </div>
                    </div>

                    <div className="pb-3">
                        <TextArea
                            placeholder="Indicare denominazione e indirizzo completo e attivitò dei sub-appaltatori ad alto rischio (es: stoccaggio, etichettatura, etc.)"
                            value={ggNotificationCoCState.tabUpdateRequest.subcontractedActivity}
                            onChangeText={(text) => dispatch(setTabUpdateSubcontractedActivity(text))}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '24px', justifyContent: 'flex-end' }}>
                        <Button
                            variant="solid"
                            color="orange"
                            size="md"
                            iconPosition="off"
                            label="Salva scheda"
                            onClick={() => dispatch(GGNotificationTabUpdate({body: ggNotificationCoCState.tabUpdateRequest, id: ggNotificationCoCState.tabIdToUpdate}))}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}